import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import './WithdrawFunds.scss';
import { RootState } from '../../../configs/store';
import Loading from '../../Loading/Loading';
import BankTransfer from '../DepositFunds/Methods/BankTransfer/BankTransfer';
import PaymentTabs from '../PaymentTabs/PaymentTabs';
import WalletSelection from '../WalletSelection/WalletSelection';

function WithdrawFunds() {
  const [selectedTab, setSelectedTab] = useState(0);
  const [paymentMethod, setPaymentMethod] = useState('bank');

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { customer, localWalletSelected, historySelectedWallet }  = useSelector((state: RootState) => state.auth);
  const { limits } = useSelector((state: RootState) => state.account);
  const [activeWallet, setActiveWallet] = useState(null);

  useEffect(() => {
    if (!historySelectedWallet){
      dispatch.auth.updateHistoryWallet(localWalletSelected);
    }
  }, []);

  useEffect(() => {
    if (!activeWallet){
      setActiveWallet(historySelectedWallet);
    }
  }, [historySelectedWallet]);

  const changeSelectedWallet = useCallback((wallet) => {
    setActiveWallet(wallet);
    dispatch.auth.updateHistoryWallet(wallet);
  }, []);

  const onTabChange = (event, value: number) => {
    setSelectedTab(value);
    setPaymentMethod(event.currentTarget.id);
  };

  const tabs = [
    { title: 'withdrawFunds.bankTransfer', description: 'withdrawFunds.bankDetailsTooltip', id:'bank' }
  ];

  return (
    <div className="withdraw-funds">
      <div className="withdraw-funds__section">
        <div className="withdraw-funds__header">{ t('withdrawFunds.choosePayment') }</div>
        <div className="withdraw-funds__description">
          <p>{ t('withdrawFunds.description') }</p>
        </div>

        {
          activeWallet &&
          <WalletSelection activeWallet={ activeWallet } customer={ customer } changeSelectedWallet={ changeSelectedWallet } />
        }
        <PaymentTabs selectedTab={ selectedTab } onChange={ onTabChange } tabs={ tabs } />
        {
          !!customer.activatedAt && !customer.isBlocked && customer.isVerifiedForWithdrawal && customer.isVerified && paymentMethod === 'bank' && (
            <>
              <Loading contained  />
              { activeWallet && <BankTransfer customer={ customer } activeWallet={ activeWallet } withdraw /> }
            </>
          )
        }
        {
          !customer.activatedAt && paymentMethod === 'bank'  && <p className="withdraw-funds__blocked">{ t('withdrawFunds.notActivated') }</p>
        }
        {
          (!customer.isVerifiedForWithdrawal || !customer.isVerified) && paymentMethod === 'bank'&& (
            <p className="withdraw-funds__blocked">{ t('withdrawFunds.notVerified') }</p>
          )
        }
        {
          (customer.isBlocked || limits.isBlocked) && <p className="withdraw-funds__blocked">{ t('withdrawFunds.blocked') }</p>
        }
      </div>
    </div>

  );
}

export default WithdrawFunds;
